import { render, staticRenderFns } from "./Repondant.vue?vue&type=template&id=6ffe8a99"
import script from "./Repondant.vue?vue&type=script&lang=js"
export * from "./Repondant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports